import { render, staticRenderFns } from "./ModalDocumento.vue?vue&type=template&id=974ce650"
import script from "./ModalDocumento.vue?vue&type=script&lang=js"
export * from "./ModalDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('974ce650')) {
      api.createRecord('974ce650', component.options)
    } else {
      api.reload('974ce650', component.options)
    }
    module.hot.accept("./ModalDocumento.vue?vue&type=template&id=974ce650", function () {
      api.rerender('974ce650', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/formalizacionactas/complementainfo/ModalDocumento.vue"
export default component.exports